import { Stack, Text, ThemeIcon } from "@mantine/core";
import type { ReactNode } from "react";

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <Stack gap="md" align="center" py="xl">
      <ThemeIcon size={64} radius="xl" variant="light" color="gray">
        {icon}
      </ThemeIcon>
      <Stack gap={4} align="center">
        <Text fw={600} size="md">
          {title}
        </Text>
        {description && (
          <Text c="dimmed" size="sm" ta="center" maw={420}>
            {description}
          </Text>
        )}
      </Stack>
      {action}
    </Stack>
  );
}
